/**
 * ImageUnavailable.jsx
 * Created by Destin Frasier on 8/11/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { IconPhotoUnavailable } from './icons/Icons';


export default function ImageUnavailable({
    isStretchy = false,
    className
}) {
    const IMAGE_URL = `${process.env.CDN}/img/global/unavailable/image-unavailable.jpg`;

    return (
        <div className={cx('rec-image-unavailable-wrap', className, {
            stretchy: isStretchy
        })}>
            <figure>
                <IconPhotoUnavailable />
                <figcaption>Photo Unavailable</figcaption>
            </figure>
            {isStretchy && (
                <div
                    className="img"
                    role="img"
                    aria-label="Unavailable"
                    style={{ backgroundImage: `url(${IMAGE_URL})` }} />
            )}
            {!isStretchy && (
                <img
                    src={IMAGE_URL}
                    alt="Unavailable"
                    aria-label="Unavailable" />
            )}
        </div>
    );
}

ImageUnavailable.propTypes = {
    isStretchy: PropTypes.bool,
    className: PropTypes.string
}
